import { Image } from "antd"
import { useSelector, patch, useDispatch } from "react-redux";
import { useState } from "react";
import classes from "./ImageCard.module.css";
import { TiTickOutline } from "react-icons/ti";
import isExistInArray from "../../utils/isExistsInArray";
import { useEffect } from "react";
import { cmsMediaSelectActions } from "../../store";
const ImageCard = (props) => {

    const selectedList = useSelector(state => state.cmsMediaSelect.list)
    useEffect(() => {
        const { status, index } = isExistInArray(selectedList, { src, caption });
        setIsSelected(status)
    }, [selectedList]);
    const { imgProps, ...params } = props;
    const { src, caption } = imgProps;
    const [isSelected, setIsSelected] = useState(false);
    const dispatch = useDispatch();
    return (
        <div
            className={`${classes["image-card"]} ${isSelected && classes["selected"]}`}
            onClick={(e) => {
                e.stopPropagation();
                !isSelected && !params.multiple && dispatch(cmsMediaSelectActions.addSelectedItem({ media: { src, caption, "type": "image" }, mode: "single" }));
                isSelected && !params.multiple && dispatch(cmsMediaSelectActions.deleteSelectedItem({ media: { src, caption, "type": "image" }, mode: "single" }));
                !isSelected && params.multiple && dispatch(cmsMediaSelectActions.addSelectedItem({ media: { src, caption, "type": "image" }, mode: "multiple" }));
                isSelected && params.multiple && dispatch(cmsMediaSelectActions.deleteSelectedItem({ media: { src, caption, "type": "image" }, mode: "multiple" }));
            }}
        >
            <Image {...imgProps} />
            <div className={classes["caption"]}>{caption}</div>
            {isSelected ? <p className={classes["tick-icon"]}><TiTickOutline color="white" /></p> : (() => { })()}
        </div >
    )
}
export default ImageCard